function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenuCampaign2Outline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 6.91v7.668c-.53 0-1.034.2-1.416.566a1.9 1.9 0 00-.59 1.356c0 .507.209.99.59 1.357.37.353.886.566 1.416.566v7.666c0 .508-.21.991-.591 1.357-.37.354-.886.566-1.415.566h-24c-.53 0-1.034-.2-1.416-.566a1.9 1.9 0 01-.59-1.357v-7.666c.529 0 1.033-.2 1.415-.566a1.9 1.9 0 00.59-1.357c0-.507-.209-.99-.59-1.356a2.069 2.069 0 00-1.416-.566V6.91c0-.507.21-.99.591-1.357a2.07 2.07 0 011.415-.566h24c.53 0 1.034.2 1.416.566.37.354.59.85.59 1.357zm-3.459 7.668a4.091 4.091 0 011.465-1.404V6.91H3.993v6.263a4.092 4.092 0 011.465 1.404 3.63 3.63 0 010 3.822 4.09 4.09 0 01-1.465 1.403v6.263h24v-6.263a4.09 4.09 0 01-1.464-1.404 3.63 3.63 0 01-.542-1.91c0-.673.185-1.334.542-1.912h.012zm-16.541 0h1.993v3.833H10v-3.834zm1.993-5.756H10v3.833h1.993V8.822zM10 20.322h1.993v3.833H10v-3.833z",
    fill: props.color
  }));
}

export default SvgIconMenuCampaign2Outline;